import React, { useState } from 'react'
import classNames from 'classnames'
import './styles.scss'
import { BaseRouteParams } from 'hocs'
import { useParams, useHistory } from 'react-router-dom'
import MoneyComponent from 'uiComponents/money'
import { useSelector } from 'react-redux'
import { getActiveAccountSlug } from 'auth/selectors'
import { ProductListItemProduct } from './types'
import { useTranslation } from 'translations'

interface ProductListItemProps {
    product: ProductListItemProduct
    children: React.ReactNode
}

export const ProductListItem = ({ product, children }: ProductListItemProps) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const activeAccountSlug = useSelector(getActiveAccountSlug)
    const [expanded, setExpanded] = useState(false)
    const [hasExpanded, setHasExpanded] = useState(false)
    const summary = product.pricingSummary
    const history = useHistory()

    const toggleExpanded = () => {
        setExpanded((prev) => {
            if (!prev) setHasExpanded(true)
            return !prev
        })
    }

    return (
        <div className={classNames('product-list-item', { expanded })}>
            <div className="header" onClick={toggleExpanded}>
                <div
                    className="thumbnail"
                    style={product.imageUrl ? { backgroundImage: `url(${product.imageUrl})` } : undefined}
                />
                <div className="info">
                    <div className="name">{product.name}</div>
                    <div className="description" title={product.description}>
                        {product.description}
                    </div>
                </div>
                {summary && (
                    <div className="header-end">
                        <div className={classNames('summary-fade price-summary', { hidden: expanded })}>
                            {summary.annualTotal != null && activeAccountSlug && (
                                <div className="price-item">
                                    <label>{summary.contract ? t('memberships.productsList.perYear') : t('memberships.productsList.annualTotal')}</label>
                                    <MoneyComponent amount={summary.annualTotal} accountSlug={activeAccountSlug} />
                                </div>
                            )}
                            {summary.upfrontTotal != null && activeAccountSlug && (
                                <div className="price-item">
                                    <label>{t('memberships.productsList.twoYearsTotal')}</label>
                                    <MoneyComponent amount={summary.upfrontTotal} accountSlug={activeAccountSlug} />
                                </div>
                            )}
                            {summary.monthlyTotal != null && activeAccountSlug && (
                                <div className="price-item">
                                    <label>{t('memberships.productsList.monthlyTotal')}</label>
                                    <MoneyComponent amount={summary.monthlyTotal} accountSlug={activeAccountSlug} />
                                </div>
                            )}
                        </div>
                        <div className={classNames('summary-fade', { hidden: !expanded })}>
                            <div
                                className="view-pricing-plans"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    history.push(`/account/${accountSlug}/products/pricing/${product.id}/detail`)
                                }}
                            >
                                <span>{t('memberships.productsList.seeAllPricingPlans')}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={classNames('collapsible', { expanded })} {...({ inert: !expanded || undefined } as any)}>
                <div className="collapsible-content">
                    <div className="expanded-content">{hasExpanded && children}</div>
                </div>
            </div>
        </div>
    )
}
